import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  CircularProgress,
  Typography,
  Alert,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CardRouter from '../cards/CardRouter';
import { useBuild } from '../contexts/BuildContext';


const LookupHitDialog = ({ open, index, docId, onClose, title = 'Details' }) => {
  const { searchApi } = useBuild();
  const [hit, setHit] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open || !index || !docId) {
      return;
    }

    const fetchDocument = async () => {
      setLoading(true);
      setError(null);
      setHit(null);

      try {
        const result = await searchApi.lookupDocument(index, docId);
        
        if (result.error) {
          setError(result.error);
        } else if (result.result) {
          // Transform the result to match the CardRouter expected format
          const document = {
            _id: result.result._id || docId,
            _index: index,
            _source: result.result._source || result.result,
          };
          setHit(document);
        } else {
          setError('No document found');
        }
      } catch (err) {
        setError(err.message || 'Failed to fetch document');
      } finally {
        setLoading(false);
      }
    };

    fetchDocument();
  }, [open, index, docId, searchApi]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {title}
        <IconButton
          onClick={onClose}
          sx={{ color: 'text.secondary' }}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        )}

        {error && !loading && (
          <Alert severity="error" sx={{ my: 2 }}>
            <Typography variant="body2">
              Error: {error}
            </Typography>
          </Alert>
        )}

        {hit && !loading && (
          <CardRouter hit={hit} />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default LookupHitDialog;

